// 不良情報のレビュー情報
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import apiAxios from '../utils/apiAxios';
import { AnyAction, Dispatch } from "redux";

export type ReviewAction = "approve" | "reject"

export type ReviewHistory = {
    reviewer_level: number;
    reviewer_id: string;
    reviewer_name: string;
    comments: string;
    status: string;
    updatstatus_at: string;
}

export type StatusSummary = {
    level_1_status: string;
    level_1_reviewer: string;
    level_2_status: string;
    level_2_reviewer: string;
}

// defect_reportsのレビュー情報
export type DefectReportsReview = {
    po_data_num: string;
    po_desc_num: string;
    mach_seq: number;
    failure_count: number;
    branch_id: number;
    review_history: ReviewHistory[];
    status_summary: StatusSummary;
}

export type DefectReportsReviews = {
    defectReportsReviews:DefectReportsReview[]
}

const initialState:DefectReportsReviews = {
    defectReportsReviews:[]
};

export const defectReportsReviewsSlice = createSlice({
    name: 'defectReportsReviews',
    initialState,
    reducers: {
        setDefectReportsReviews: (state, action: PayloadAction<DefectReportsReview[]>) => {
            state.defectReportsReviews = action.payload
        },
    }
})

const { setDefectReportsReviews
} = defectReportsReviewsSlice.actions;

// レビュー情報取得
const fetchDefectReportsReviews = (po_data_num:string, po_desc_num:string, mach_seq:number, failure_count:number) => {
    return async (dispatch:Dispatch<AnyAction>) => {
        const url = `/defect_reports_reviews?po_data_num=${po_data_num}&po_desc_num=${po_desc_num}&mach_seq=${mach_seq}&failure_count=${failure_count}`;
        const response = await apiAxios.get<DefectReportsReview[]>(url);
        try {
            if (response.data !== null) { // nullで帰ってこないはずだが暫定
                dispatch(setDefectReportsReviews(response.data))
            }
        } catch (error) {
            window.alert('レビュー情報取得エラー');
            console.error(error)
        }
    }
}

// 入力チェック
const validateDefectReportsReviews = (dispatch:Dispatch<AnyAction>, 
    defectReportsReviews:DefectReportsReview[]) => {
    // 入れる予定
    return false;
}

// 不良不足報告書の承認
const postDefectReportsReviews = (defectReportsReviews:DefectReportsReview[], 
    reviewerId:string, reviewAction:ReviewAction) => {
    return async (dispatch:Dispatch<AnyAction>) => {
        // 入力チェック
        const isError = await validateDefectReportsReviews(dispatch, defectReportsReviews);
        console.log(isError);
        if (!isError) {
            for (const d of defectReportsReviews) {
                const body = [{
                    "po_data_num": d.po_data_num,
                    "po_desc_num": d.po_desc_num,
                    "mach_seq": d.mach_seq,
                    "failure_count": d.failure_count,
                    "branch_id": d.branch_id,
                    "reviewer_id": reviewerId,
                    "action": reviewAction
                }]
                console.log(body);
                try {
                    const response = await apiAxios.post("/defect_reports_reviews", body);
                    console.log(response);
                } catch (error) {
                    window.alert('不良不足報告書の承認登録エラー' + error);
                }
            }
        }
    }
}

export { fetchDefectReportsReviews, postDefectReportsReviews }
export default defectReportsReviewsSlice.reducer;